var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Card_list"},[_c('Search'),_c('ArtHots'),_c('NowBack',{attrs:{"backImg":_vm.backImg}}),_c('Tags'),_c('NowQrcode'),_c('Links'),_c('Todo'),_c('CopyRight')],1)}
var staticRenderFns = []

export { render, staticRenderFns }